export default __webpack_public_path__ + "static/media/lodgify_step6.54ac5475.jpg";